import React, { useCallback, useState } from 'react';
import { Search, FileSpreadsheet } from 'lucide-react';
import ProspeccaoGeoView from './ProspeccaoGeoView';
import ProspeccaoUploadView from './ProspeccaoUploadView';
import FilaProspeccaoBanner from './FilaProspeccaoBanner';

type Aba = 'geo' | 'lista';

/** Casca de Prospecção com 2 abas: Busca Geográfica (Google) e Lista Fria (upload + Lemit). */
const ProspeccaoView: React.FC = () => {
    const [aba, setAba] = useState<Aba>('geo');
    // Incrementado quando um job da fila termina — a Lista Fria recarrega com o
    // resultado. O banner fica AQUI, fora das abas, para o progresso do lote não
    // sumir quando você troca de aba (era exatamente o que matava o lote antes).
    const [refreshKey, setRefreshKey] = useState(0);
    const aoConcluirJob = useCallback(() => setRefreshKey((k) => k + 1), []);

    const TabButton: React.FC<{ id: Aba; label: string; icon: React.ReactNode }> = ({ id, label, icon }) => (
        <button
            onClick={() => setAba(id)}
            className={`flex items-center gap-2 px-4 py-2 text-sm font-bold rounded-full transition-all ${aba === id
                ? 'bg-primary text-white shadow-sm'
                : 'bg-gray-100 dark:bg-gray-700/50 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`}
        >
            {icon} {label}
        </button>
    );

    return (
        <div className="space-y-4">
            <div className="flex items-center gap-2 px-2 sm:px-0">
                <TabButton id="geo" label="Busca Geográfica" icon={<Search size={15} />} />
                <TabButton id="lista" label="Lista Fria" icon={<FileSpreadsheet size={15} />} />
            </div>
            <FilaProspeccaoBanner onConcluir={aoConcluirJob} />
            {aba === 'geo' ? <ProspeccaoGeoView /> : <ProspeccaoUploadView refreshKey={refreshKey} />}
        </div>
    );
};

export default ProspeccaoView;
